import React from 'react';
import { v4 as uuidv4 } from 'uuid';

// Generates unique IDs for clip paths
const getUniqueId = () => `clip-${uuidv4().substring(0, 8)}`;

/**
 * Component for clipping child elements using a circle
 */
const Clipped = ({ children, x, y, radius, ...rest }) => {
  const id = getUniqueId();
  return (
    <g {...rest}>
      <defs>
        <clipPath id={id}>
          <circle cx={x} cy={y} r={radius} />
        </clipPath>
      </defs>
      <g clipPath={`url(#${id})`}>
        {children}
      </g>
    </g>
  );
};

/**
 * Component for clipping child elements using a rectangle
 */
export const RectClipped = ({ children, x, y, width, height, ...rest }) => {
  const id = getUniqueId();
  return (
    <g {...rest}>
      <defs>
        <clipPath id={id}>
          <rect x={x} y={y} width={width} height={height} />
        </clipPath>
      </defs>
      <g clipPath={`url(#${id})`}>
        {children}
      </g>
    </g>
  );
};

export default Clipped; 